import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

export const EditPersonDialogWrapper = styled.div`
  transition: all 0.2s ease;
  position: fixed;
  overflow: hidden;
  bottom: 0;
  min-width: 312px !important;
  width: calc(30% - 80px);
  height: fit-content;
  transform: none;
  min-width: 200px;
  top: 30%;
  z-index: 101;
  padding: 1em 1.5em 1.5em;
  background: #fff;
  border-radius: 5px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  @media (min-width: 1400px) {
    width: 40%;
  }

  @media (max-width: 1400px) {
    width: 50%;
  }

  @media (max-width: 767px) {
    width: 80%;
    right: 68px;
  }

  @media (max-width: 599px) {
    width: 80%;
    right: 10%;
  }
`

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`

export const BodyWrapper = styled.div`
  display: flex;
  justify-content: space-around;
`

export const EditAvatarWrapper = styled.div``

export const EditAvatar = styled.img<{
  windowWidth: number
}>`
  width: ${({ windowWidth }) => (windowWidth < 500 ? '7em' : '8em')};
  height: ${({ windowWidth }) => (windowWidth < 500 ? '7em' : '8em')};
  border-radius: 50%;
  margin-bottom: 1em;
  margin-right: ${({ windowWidth }) => (windowWidth < 500 ? '1em' : '0')};
  &:hover {
    color: #2164db;
    cursor: pointer;
  }
`

export const EditAvatarIcon = styled(FontAwesomeIcon)`
  &:hover {
    color: #2164db;
    cursor: pointer;
  }
`

export const PersonHeader = styled.h3`
  text-align: center;
  font-size: 1.3em;
  font-weight: 400;
  margin: 0 0 1.2em;
  line-height: 1.2;
`

export const CloseButton = styled(FontAwesomeIcon)`
  color: #2164db;
  font-size: 1.5em;
  &:hover {
    cursor: pointer;
    color: #0a0a0a;
  }
`

export const ButtonsWrapper = styled.div<{ windowWidth: number }>`
  text-align: right;
  padding: ${({ windowWidth }) => (windowWidth < 500 ? '0' : '8px')};
  width: ${({ windowWidth }) => (windowWidth < 500 ? '180px' : '100%')};
`

export const Backdrop = styled.div`
  position: fixed;
  z-index: 100;
  width: 102vw;
  left: -1vw;
  height: 102vh;
  top: -1vh;
  background: #000;
  opacity: 0.8;
`

export const ContractIcon = styled(FontAwesomeIcon)`
  margin-top: 2px;
  margin-right: 6px;
  color: #7e7e7e;
`

export const ContractText = styled.p`
  color: #7e7e7e;
  margin-bottom: 6px;
`

export const PasswordIcon = styled(FontAwesomeIcon)`
  margin-top: 2px;
  margin-right: 6px;
  color: #7e7e7e;
`

export const PasswordText = styled.p`
  color: #7e7e7e;
  margin-bottom: 6px;
  &:hover {
    font-weight: 700;
    color: #696868;
    cursor: pointer;
  }
`
